import axios from "../http-client/axios";
import { PARAMORE_URL } from "../urls/base-urls";
//const PARAMORE_URL = "http://localhost:8304";

const headers = {
  "content-type": "application/json",
  //"crm": "1515"  
}

export async function getPopUps() {
    const resp = await axios({
        url: `${PARAMORE_URL}/content/communique/popup`,
        method: "get",
        headers: headers,
    });
    
    return resp.data;
}

export async function visualizePopUp(communiqueId) {
    const request = {
        communiqueId: communiqueId
    };
    const resp = await axios.post(`${PARAMORE_URL}/content/communique/visualized`, request, {
        headers: headers,
    });

    return resp;
}
